<script setup lang="ts">
import { computed } from 'vue';
import {ImpactViolationTypeEnum} from "@/api/dx-backend";

// Import all violation type images
import physicalImage from "@/assets/images/impact_violation/Phisical.webp";
import mentalImage from "@/assets/images/impact_violation/Mental.webp";
import energyImage from "@/assets/images/impact_violation/Energy.webp";
import heatImage from "@/assets/images/impact_violation/Heat.webp";
import coldImage from "@/assets/images/impact_violation/Cold.webp";
import lightImage from "@/assets/images/impact_violation/Light.webp";
import darknessImage from "@/assets/images/impact_violation/Dark.webp";
import noneImage from "@/assets/images/impact_violation/None.webp";

interface Props {
  violationType: ImpactViolationTypeEnum;
}

const props = defineProps<Props>();

// Map violation types to their corresponding imported images
const imageMap: Record<string, string> = {
  [ImpactViolationTypeEnum.Physical]: physicalImage,
  [ImpactViolationTypeEnum.Mental]: mentalImage,
  [ImpactViolationTypeEnum.Energy]: energyImage,
  [ImpactViolationTypeEnum.Heat]: heatImage,
  [ImpactViolationTypeEnum.Cold]: coldImage,
  [ImpactViolationTypeEnum.Light]: lightImage,
  [ImpactViolationTypeEnum.Darkness]: darknessImage,
  [ImpactViolationTypeEnum.None]: noneImage
};

const imageSrc = computed(() => {
  return imageMap[props.violationType] || '';
});

</script>

<template>
  <img
    v-if="imageSrc"
    :src="imageSrc"
    :alt="`${props.violationType} violation type`"
  />
</template>

<style scoped>
</style>